function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M35.4049 7.89115C37.1717 7.89115 38.9352 8.60054 40.266 10.0258C42.9509 12.909 42.9509 17.7478 40.3189 20.6732L34.5529 26.9991L39.873 32.4953L45.639 26.1693L45.6555 26.1498L45.672 26.1303C51.0979 20.0972 51.0318 10.3805 45.53 4.47111C42.8452 1.58799 39.2489 0 35.4049 0C33.5291 0 31.6963 0.380728 29.9659 1.13242C28.1561 1.91666 26.5446 3.06535 25.1741 4.54921L25.1212 4.60778L25.0684 4.66636L24.8538 4.90716L24.6391 4.66636L24.5863 4.60453L24.5301 4.54596C23.1596 3.06535 21.5481 1.9134 19.7383 1.12917C18.0013 0.380728 16.1718 0 14.296 0C10.452 0 6.8524 1.58799 4.16756 4.47111C-1.33423 10.3838 -1.39698 20.1005 4.02886 26.1303L4.04537 26.1498L4.06188 26.1693L9.82786 32.4953L15.148 26.9991L9.38204 20.6765C6.75003 17.7478 6.75003 12.9122 9.43157 10.0291C10.7624 8.60054 12.5259 7.89115 14.2927 7.89441C16.0925 7.89441 17.8956 8.62983 19.243 10.0877L24.8471 16.4136L30.4513 10.0877C31.802 8.62658 33.6051 7.89115 35.4049 7.89115Z",
  fill: "#E3E3E3"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24.8611 37.6692L15.162 27.0283L9.8418 32.5245L19.5409 43.1621L24.8611 48.9999L30.1812 43.1621L39.8804 32.5245L34.5602 27.0283L24.8611 37.6692Z",
  fill: "white"
});

var SvgLightLogo = function SvgLightLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLightLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/light-logo.c0a20ec3.svg";
export { ForwardRef as ReactComponent };